// extracted by mini-css-extract-plugin
export default {"error-wrapper":"Error404_error-wrapper__WoAeH","img-wrapper":"Error404_img-wrapper__AuqJt","error-content-area":"Error404_error-content-area__xHQPo"};